<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <!-- 选择餐厅 -->
        <el-form-item label="餐厅">
          <el-select
            :disabled="!!form.restaurantId"
            v-model="form.restaurantId"
            placeholder="请选择餐厅"
            class="fix-width"
          >
            <el-option
              v-for="item in restaurantList"
              :key="item.restaurantId"
              :label="item.title"
              :value="item.restaurantId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createDesk, updateDesk, findList, findAll } from '@/api/food'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'DeskEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      restaurantList: [],
      branchList: [],
      form: {
        deskId: '',
        branchId: '',
        restaurantId: '',
        title: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        restaurantId: [
          { required: true, trigger: 'blur', message: '请选择餐厅' },
        ],
        branchId: [{ required: true, trigger: 'blur', message: '请选择门店' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    //获取所有餐厅
    async findList() {
      const res = await findAll({})
      if (!res) return
      this.restaurantList = res
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改餐桌'
        this.form.order = row.basic.order
        this.form.restaurantId = row.basic.restaurantId
        this.form.title = row.title
        this.form.branchId = row.extra.branchId
        this.form.deskId = row.deskId
      } else {
        this.title = '新增餐桌'
      }
      this.findList()
      this.getAllBranchs()
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const deskId = this.form.deskId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${deskId ? '修改' : '新增'}餐桌吗`,
            null,
            async () => {
              deskId ? await updateDesk(data) : await createDesk(data)
              this.$baseMessage(
                `${deskId ? '修改' : '新增'}餐桌成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
</style>
